import script from "./detail80.vue?vue&type=script&setup=true&lang=js"
export * from "./detail80.vue?vue&type=script&setup=true&lang=js"

import "./detail80.vue?vue&type=style&index=0&id=225e61c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d637f08be657c424b9582f6be932ff98/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225e61c8"]])

export default __exports__